var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('AdminNavbar'),_c('div',{staticClass:"home"},[_c('img',{attrs:{"alt":"logo","src":require("../assets/logowatch.png")}}),_c('HelloWorld')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }